// Slot Machine Factory class
//
// Used to create a unique slot machine for cascading slots
//
// Slot machine class
//
// Used to create, spin and animate reels as a group
// Contains no logic.
//
// Add this class to config.json under the "controllers" section, telling it which reels it is managing
//      "controllers": {
//        "slotMachine": { "reels": [ "reel0", "reel1", "reel2", "reel3", "reel4"]}
//      }
//
// addInjectors - adds to a list of injector pre/post pairs
// selectInjectors - selects the injector pre/post pair defined in addInjectors
// setInjectors - sets injector pre/post pairs now
//
// infiniteSpin - starts the reels infinitely spinning
// stopReels - signals reels that are infinitely spinning to stop on positions
//

// For backward compatibility
GameSlotMachine = undefined;

GameSlotMachineFactory = {};
GameSlotMachineFactory.slotMachines = [];

//
GameSlotMachineFactory.createSlotMachine = function () {
  var newSlotMachine = {};
  newSlotMachine.reels = [];
  newSlotMachine.groupAnalysers = {};
  newSlotMachine.symbolCreationCallbacks = {};
  newSlotMachine.slamStopRequested = false;

  newSlotMachine.addReel = function (reelId) {
    if (resourceManager.get(reelId).Props.type !== "cascadeReel") {
      console.error(
        "GameSlotMachine can only manage 'cascadeReels', " +
          reelId +
          " is type '" +
          resourceManager.get(reelId).Props.type +
          "'"
      );
      return;
    }

    var reel = resourceManager.get(reelId);
    reel.reelIndex = this.reels.length;
    this.reels.push(reel);
  };

  newSlotMachine.initialise = function (json) {
    var containerName = json.containerName;
    var stripContainer = resourceManager.hasResource(
      containerName + ":reelStripContainer"
    )
      ? resourceManager.get(containerName + ":reelStripContainer")
      : undefined;
    var boxContainer = resourceManager.hasResource(
      containerName + ":reelBoxContainer"
    )
      ? resourceManager.get(containerName + ":reelBoxContainer")
      : undefined;

    for (var i = 0; i < json.reels.length; ++i) {
      this.addReel(containerName + ":reelContainer:" + json.reels[i]);

      if (stripContainer !== undefined) {
        stripContainer.addChild(this.reels[i].animationStripContainer);
      }

      if (boxContainer !== undefined) {
        boxContainer.addChild(this.reels[i].animationBoxContainer);
      }
    }
  };

  newSlotMachine.clearReels = function () {
    newSlotMachine.slamStopRequested = false;

    let delay = 100;
    let multiplier = 1;
    const license = gameData.license.toUpperCase();
    if (license === 'DE') {
      const minGameTime = gdk.minGameTime;
      if (minGameTime > 2) {
        multiplier = minGameTime * 0.5;
        // cap
        if (multiplier > 2.5) {
          multiplier = 2.5;
        }
      }
    }

    for (var i = 0; i < this.reels.length; ++i) {
      this.reels[i].clearReel(delay * i * multiplier);
    }
  };

  newSlotMachine.slamStop = function () {
    if (!newSlotMachine.slamStopRequested) {
      newSlotMachine.slamStopRequested = true;

      for (var i = 0; i < this.reels.length; i++) {
        this.reels[i].requestSlamStop();
      }
    }
  };

  newSlotMachine.dropInitialSymbols = function (
    abovePositions,
    positions,
    belowPositions,
    postApperturePadding,
    cashPotData
  ) {
    for (var reel = 0; reel < this.reels.length; reel++) {
      positions[reel].push(belowPositions[reel][0]);
    }

    const delay = 100;
    const anticipationDelay = gameController.calculateDelaysForAnticipation();
    for (var i = 0; i < this.reels.length; ++i) {
      this.reels[i].fillInitialSymbols(
        delay * i + anticipationDelay[i],
        positions,
        cashPotData
      );
    }
  };

  newSlotMachine.stopReels = function (
    abovePositions,
    positions,
    belowPositions,
    postApperturePadding
  ) {
    var allLandingSymbols = [];
    for (var i = 0; i < positions.length; ++i) {
      if (positions[i] === undefined) {
        allLandingSymbols.push(undefined);
      } else {
        allLandingSymbols.push(positions[i].slice());
      }
    }

    // Validate data sizes
    if (this.reels.length !== allLandingSymbols.length) {
      console.error(
        "Number of reels configured for slot machine (" +
          this.reels.length +
          ") is different to number of reel positions (" +
          allLandingSymbols.length +
          ")"
      );
      return;
    }

    for (var i = 0; i < this.reels.length; ++i) {
      if (allLandingSymbols[i] !== undefined) {
        if (
          this.reels[i].configParams.appertureHeight !==
          allLandingSymbols[i].length
        ) {
          console.error(
            "Number of rows configured for slot " +
              this.reels[i].Props.FQN +
              " (" +
              this.reels[i].configParams.appertureHeight +
              ") is different to number of rows in positions (" +
              allLandingSymbols[i].length +
              ")"
          );
          return;
        }
      }
    }

    // Merge in above symbols
    if (abovePositions !== undefined) {
      for (var i = 0; i < this.reels.length; ++i) {
        for (var j = abovePositions[i].length - 1; j >= 0; --j) {
          allLandingSymbols[i].unshift(abovePositions[i][j]);
        }
      }
    }
    // Merge in below symbols
    if (belowPositions !== undefined) {
      for (var i = 0; i < this.reels.length; ++i) {
        for (var j = 0; j < belowPositions[i].length; ++j) {
          allLandingSymbols[i].push(belowPositions[i][j]);
        }
      }
    }

    if (postApperturePadding === undefined) {
      postApperturePadding = 0;
    }

    // Signal all reels to stop
    for (var i = 0; i < this.reels.length; ++i) {
      var reel = this.reels[i];

      reel.requestStop();
    }

    // Wait until all reels are ready to stop
    Reflex.addToUpdate(this.checkForStopReels);
  };

  newSlotMachine.checkForStopReels = function () {
    for (var i = 0; i < newSlotMachine.reels.length; ++i) {
      if (
        !newSlotMachine.slamStopRequested /*&& !newSlotMachine.reels[i].preInjector.canStop*/
      ) {
        return;
      }
    }

    // We can stop the reels
    for (var i = 0; i < newSlotMachine.reels.length; ++i) {
      var reel = newSlotMachine.reels[i];
      reel.stop();
    }

    Reflex.removeFromUpdate(newSlotMachine.checkForStopReels);
  };

  GameSlotMachineFactory.slotMachines.push(newSlotMachine);

  if (GameSlotMachineFactory.slotMachines.length === 1) {
    // This is the first slot machine, so assign it to the global variable
    slotMachine = newSlotMachine;
  }

  return newSlotMachine;
};

GameSlotMachineFactory.onAbortGame = function () {
  // Retore state on all reels and injectors
  for (
    var slotMachineIndex = 0;
    slotMachineIndex < GameSlotMachineFactory.slotMachines.length;
    slotMachineIndex++
  ) {
    var slotMachine = GameSlotMachineFactory.slotMachines[slotMachineIndex];
    for (var i = 0; i < slotMachine.reels.length; ++i) {
      slotMachine.reels[i].restoreState();
    }
  }
};

GameSlotMachineFactory.getSlotMachine = function (id) {
  if (typeof id === "number") {
    // This is an index
    return GameSlotMachineFactory.slotMachines[id];
  } else {
    // This is a name
    for (var i = 0; i < GameSlotMachineFactory.slotMachines.length; i++) {
      if (GameSlotMachineFactory.slotMachines[i].name === id)
        return GameSlotMachineFactory.slotMachines[i];
    }

    console.log("Slot machine " + id + " was not found");
    return undefined;
  }
};

resourceManager.registerController(
  "GameSlotMachine",
  GameSlotMachineFactory.createSlotMachine
);

messageBus.subscribe("common:AbortGame", GameSlotMachineFactory.onAbortGame);
